<template>
  <div class="container-input-filtros">
    <i class="fa fa-search icn-search"></i>
    <input
      :value="text"
      class="ipt-search"
      @input="$emit('update:text', $event.target.value)"
      @keydown="debounce(() => $emit('aplicarFiltro'), 1000, $event.key)()"
      type="text"
      :placeholder="filtro.placeholder"
    />
  </div>
</template>
<script>
export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  emits: ['aplicarFiltro', 'update:text'],
  data() {
    return {
      debounceTimeout: null
    };
  },
  methods: {
    debounce(func, wait, key) {
      return (...args) => {
        const regKey = /^[a-zA-Z0-9]$|Backspace/;
        if (!regKey.test(key)) return;

        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
  },
}
</script>
